<template>
	<sacleBox>
		<!-- 模拟数据开关：仅对 MOCK_SCHOOL_GUIDS 中的院校显示 -->
		<div v-if="mockEnable" class="openclosebtn" @click.stop="openbtnshowtext">{{ openbtntext ? '关闭' : '开启' }}</div>
		<div class="appconten">
			<div class="usertitles">
				<img class="userimg" src="./../../assets/usertoptitle.png" alt="" srcset="" />
				<p class="userback" @click="callbackgr()">
					<img style="transform: rotateZ(90deg);margin-right: 20px;" src="./../../assets/backuser.svg" alt="" srcset="" />
					<span>返回</span>
				</p>
				<p class="usertiefonts">学员实训技能画像</p>
			</div>
			<div class="usermessages">
				<div class="usermitem">
					<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
					<div class="usermessagelist">
						<div class="usermesbox">
							<img v-if="usersa.ui_photoPath" style="width: 60px;height: 60px;border-radius: 50%;" :src="usersa.ui_photoPath" alt="" srcset="" />
							<img v-else style="width: 60px;height: 60px;border-radius: 50%;" src="./../../images/header.png" alt="" srcset="" />
							<div class="usermename" style="margin-left: 10px;">
								<p style="margin-bottom: 10px;font-weight: 600;font-size: 1.1rem;">{{ usersa.ui_realName }}</p>
								<p>
									<span style="display: block;font-size: 16px;">学号：</span>
									<span>{{ usersa.ui_joyNumber }}</span>
								</p>
							</div>
						</div>
						<div class="usermesbox" style="background-color: #13D0B2;height: 28%;">
							<div class="usermename">
								<p style="display: flex;">
									<span style="display: block;font-size: 1rem;">所属专业：</span>
									<span style="font-size: 1rem;" :title="usersa.pro_name">{{ usersa.pro_name ?? '' }}</span>
								</p>
								<div>
									<p style="font-size: 16px;">所属班级：</p>
									<p style="word-break:break-all;font-size: 14px;" :title="usersa.cla_name">{{ usersa.cla_name ?? '' }}</p>
								</div>
							</div>
						</div>
						<div class="usermesbox" style="height: 28%;background-color: #F6A645;justify-content: center;">
							<span class="el-icon-time" style="font-size: 4rem;color: #fff;"></span>
							<div class="usermename" style="margin-left: 0.8rem;">
								<p style="margin-bottom: 0.4rem;">累计实训时长</p>
								<p>
									<span style="font-size: 1.3rem;color: #0000FF;font-weight: 600;">{{ usersa.timeLength }}</span>
									<span style="font-size: 1rem;margin-left: 0.4rem;">小时</span>
								</p>
							</div>
						</div>
					</div>
					<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
				</div>

				<div class="usermitem" style="width: 30%;margin-left: 20px;">
					<div class="usermitems" style="height: 30%;">
						<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
						<div class="usermitestect">
							<div style="width: 35%;margin-right: 12px;" :title="showtitle(value, 0)">
								<el-select @change="changeselect" v-model="value" placeholder="请选择班级">
									<el-option v-for="item in options" :key="item.cla_guid" :label="item.cla_name" :value="item.cla_guid"></el-option>
								</el-select>
							</div>
							<div style="width: 23%;margin-right: 12px;" :title="showtitle(value1, 1)">
								<el-select v-model="value1" placeholder="选择学员" @change="selectuser()">
									<el-option v-for="item in options1" :key="item.ui_guid" :label="item.ui_realName" :value="item.ui_guid"></el-option>
								</el-select>
							</div>
							<div style="width: 30%;margin-right: 12px;" :title="showtitle(testuids, 2)">
								<el-select v-model="testuids" placeholder="选择设备" @change="selectstelist()">
									<el-option v-for="item in tesoptions" :key="item.sx_te_guid" :label="item.te_deviceName" :value="item.sx_te_guid"></el-option>
								</el-select>
							</div>
						</div>
						<img class="borderbottom" style="height: 90px;bottom:30px" src="./../../assets/borderbottom.png" alt="" />
					</div>
					<div class="usermitems" style="height: 70%;">
						<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
						<div style="padding: 1rem;width: 100%;height: 100%;" id="usermitemchats"></div>
						<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
					</div>
				</div>
				<div class="usermitem" style="width: 53%;margin-left: 2%;">
					<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
					<div style="padding: 1rem;width: 100%;height: 100%;">
						<p style="color: #fff;font-size: 1.4rem;letter-spacing: 1px;margin-left: 2rem;">实训数据模型</p>
						<div class="taablessc" style="width: 97%;margin-left: 1rem;margin-top: 10px;" v-if="isdatastanum != 0">
							<div class="tablesbox">
								<div class="tablesboxtr" style="font-size: 16px;" :style="{ width: titletrnodenumswidth + 'px' }"><p style="border-right: none;">序号</p></div>
								<div class="tablesboxtr" :style="{ width: addbiltysboxvontentwidth1 + 'px' }">
									<div class="biltysbox" style="border-right: none;">能力类型</div>
									<div class="biltysboxvontent">
										<p style="border-top: none;border-right: none;width: 58.5%;">名称</p>
										<p style="border-top: none;border-right: none;width: 41.5%;">评估值</p>
									</div>
								</div>
								<div class="tablesboxtr" :style="{ width: addbiltysboxvontentwidth2 + 'px' }">
									<div class="biltysbox" style="border-right: none;">能力项目</div>
									<div class="biltysboxvontent">
										<p style="border-top: none;border-right: none;width: 66.9%;">名称</p>
										<p style="border-top: none;border-right: none;width: 33.1%;">评估值</p>
									</div>
								</div>
								<div class="tablesboxtr tablesboxtrend" :style="{ width: projectsumalldom + 'px' }">
									<div class="biltysbox">考核项目数量</div>
									<div class="biltysboxvontent">
										<p>总数</p>
										<p style="border-right: none;">优秀</p>
										<p style="border-right: none;">良好</p>
										<p style="border-right: none;">一般</p>
										<p style="border-right: none;">未掌握</p>
										<p>未评测</p>
									</div>
								</div>
							</div>
						</div>
						<div class="taablessc" v-show="isdatastanum != 0" style="overflow: scroll;max-height: 68%;min-height: 65%; width: 97%;margin-left: 1rem;">
							<table border="1" class="tables" id="tablestow"></table>
						</div>

						<div class="paginationno" v-if="isdatastanum == 0">暂无实训数据</div>
					</div>

					<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
				</div>
			</div>

			<div class="usermessages">
				<div class="usermitem" style="width: 33%;">
					<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
					<div style="padding: 1rem;width: 100%;height: 100%;" id="scores"></div>
					<div class="datechoice">
						<p
							:class="{ dateactives: dateacti == 0 }"
							@click="
								dateacti = 0;
								changesore('week');
							"
						>
							周
						</p>
						<p
							:class="{ dateactives: dateacti == 1 }"
							@click="
								dateacti = 1;
								changesore('month');
							"
						>
							月
						</p>
						<!-- <p :class="{'dateactives':dateacti==2}" @click="dateacti=2">三个月</p> -->
						<p
							:class="{ dateactives: dateacti == 3 }"
							@click="
								dateacti = 3;
								changesore('year');
							"
						>
							年
						</p>
					</div>
					<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
				</div>
				<div class="usermitem" style="width: 33%;margin: 0 20px;">
					<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
					<el-empty v-if="projectsta.length == 0" style="height: 100%;" description="暂无实训项目数据,请尽快完成实训"></el-empty>
					<div style="padding: 1rem;width: 100%;height: 100%;" id="censuscharts"></div>
					<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
				</div>
				<div class="usermitem" style="width: 33%;">
					<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
					<div style="padding: 1rem;width: 100%;height: 100%;" id="timercensus"></div>
					<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
				</div>
			</div>
		</div>
	</sacleBox>
</template>

<script>
import AppOptions from '@/config/AppOptions.vue';
import $ from 'jquery';
import {
	GetClassInfoList,
	GetStudentInfoList,
	GetStudentInfo,
	GetStudentTimeLength, // 学习时长
	GetStudentTimeLengthApi, //  新学习时长
	GetStudentResultsDataList, // 实训成绩
	GetStudentResultsDataListApi, // 新实训成绩
	GetMyComprehensiveSTA, // 综合实训技能
	GetMyComprehensiveSTAPi, // 新综合实训技能
	GetMyProjectSTA, //项目分类统计
	GetMyProjectSTANewApi, // 新项目分类统计
	GetMyTrainDataSTA, // 实训数据报表
	GetMyTrainDataSTANewApi // 新实训数据报表
} from '@/request/alllog.js';
import sacleBox from '@/components/sacleBox.vue';

// ==================== 数据墙模拟数据（开启 / 关闭 开关） ====================
// 需要展示「开启 / 关闭」模拟数据开关的院校 si_guid，按需往数组里追加。
// 若按钮没出现：控制台执行 localStorage.getItem('siguid') 拿到当前院校 guid 加进来，
// 或执行 localStorage.setItem('datawallMock', '1') 后刷新，强制打开开关。
const MOCK_SCHOOL_GUIDS = [
	'f760369023c3453bb0917c0869260187',
	'86f7b581e9cd4613bc58e76c3cc8cf3d',
	'a4c15b121b2b4e82841a2eea30441c10',
	'71f98248c0f5480cb0a99b0dbc761c31'
];

// 模拟数据方案一
function mockUserDataA() {
	return {
		// 学员基本信息
		usersa: {
			ui_realName: '张三',
			ui_joyNumber: '20240001',
			pro_name: '铁道交通运营管理',
			cla_name: '2024级铁道班',
			timeLength: 128,
			ui_photoPath: ''
		},
		// 综合实训技能（雷达图）
		ability: [60, 80, 40, 70, 90],
		comprehensive: [
			{ name: '基本技能', text: '基本技能', max: 110, value: 60 },
			{ name: '工务设备故障应急处置', text: '工务设备故障应急处置', max: 110, value: 80 },
			{ name: '电务设备故障应急处置', text: '电务设备故障应急处置', max: 110, value: 40 },
			{ name: '自然灾害应急处置', text: '自然灾害应急处置', max: 110, value: 70 },
			{ name: '理论知识', text: '理论知识', max: 110, value: 90 }
		],
		// 实训时长统计（12 个月）
		traintimer: [70, 70, 76, 66, 77, 44, 80, 72, 68, 74, 79, 82],
		// 实训成绩（分）
		scoreschars: [
			['1月', 85], ['2月', 78], ['3月', 92], ['4月', 88], ['5月', 76], ['6月', 95],
			['7月', 82], ['8月', 90], ['9月', 86], ['10月', 91], ['11月', 79], ['12月', 88]
		],
		// 实训项目实训时长统计
		projectstabname: ['CTC软件基本操作', '自然灾害应急处置', '理论考核', '电务设备故障应急处置', '工务设备故障应急处置'],
		projectstab: [85, 78, 92, 66, 88],
		// 实训数据模型表格
		tableData: [
			{ projectTypeName: '基本技能', projectTypeAST: '85', projectName: 'CTC软件基本操作', projectAST: '掌握', projectSum: 10, projectBest: 6, projectGood: 3, projectGeneral: 1, projectNoEvaluating: 0, projectNoFailing: 0 },
			{ projectTypeName: '基本技能', projectTypeAST: '85', projectName: '调度命令操作', projectAST: '良好', projectSum: 8, projectBest: 4, projectGood: 3, projectGeneral: 1, projectNoEvaluating: 0, projectNoFailing: 0 },
			{ projectTypeName: '应急处置', projectTypeAST: '82', projectName: '自然灾害应急处置', projectAST: '掌握', projectSum: 15, projectBest: 9, projectGood: 4, projectGeneral: 2, projectNoEvaluating: 0, projectNoFailing: 0 },
			{ projectTypeName: '应急处置', projectTypeAST: '82', projectName: '电务设备故障应急处置', projectAST: '一般', projectSum: 5, projectBest: 1, projectGood: 1, projectGeneral: 2, projectNoEvaluating: 1, projectNoFailing: 0 },
			{ projectTypeName: '应急处置', projectTypeAST: '82', projectName: '工务设备故障应急处置', projectAST: '良好', projectSum: 12, projectBest: 6, projectGood: 4, projectGeneral: 2, projectNoEvaluating: 0, projectNoFailing: 0 },
			{ projectTypeName: '理论知识', projectTypeAST: '95', projectName: '理论考核', projectAST: '掌握', projectSum: 20, projectBest: 14, projectGood: 5, projectGeneral: 1, projectNoEvaluating: 0, projectNoFailing: 0 }
		]
	};
}

// 模拟数据方案二
function mockUserDataB() {
	return {
		usersa: {
			ui_realName: '张伟',
			ui_joyNumber: '20230088',
			pro_name: '高速铁路客运服务',
			cla_name: '2023级高铁乘务班',
			timeLength: 96,
			ui_photoPath: ''
		},
		ability: [50, 65, 35, 55, 75],
		comprehensive: [
			{ name: '基本技能', text: '基本技能', max: 110, value: 50 },
			{ name: '工务设备故障应急处置', text: '工务设备故障应急处置', max: 110, value: 65 },
			{ name: '电务设备故障应急处置', text: '电务设备故障应急处置', max: 110, value: 35 },
			{ name: '自然灾害应急处置', text: '自然灾害应急处置', max: 110, value: 55 },
			{ name: '理论知识', text: '理论知识', max: 110, value: 75 }
		],
		traintimer: [55, 60, 65, 50, 62, 38, 70, 58, 64, 60, 68, 72],
		scoreschars: [
			['1月', 76], ['2月', 82], ['3月', 88], ['4月', 79], ['5月', 85], ['6月', 90],
			['7月', 74], ['8月', 86], ['9月', 81], ['10月', 89], ['11月', 84], ['12月', 92]
		],
		projectstabname: ['CTC软件基本操作', '自然灾害应急处置', '理论考核', '电务设备故障应急处置', '工务设备故障应急处置'],
		projectstab: [76, 68, 88, 58, 80],
		tableData: [
			{ projectTypeName: '基本技能', projectTypeAST: '76', projectName: 'CTC软件基本操作', projectAST: '良好', projectSum: 9, projectBest: 4, projectGood: 3, projectGeneral: 2, projectNoEvaluating: 0, projectNoFailing: 0 },
			{ projectTypeName: '基本技能', projectTypeAST: '76', projectName: '调度命令操作', projectAST: '一般', projectSum: 7, projectBest: 2, projectGood: 2, projectGeneral: 2, projectNoEvaluating: 1, projectNoFailing: 0 },
			{ projectTypeName: '应急处置', projectTypeAST: '72', projectName: '自然灾害应急处置', projectAST: '良好', projectSum: 12, projectBest: 5, projectGood: 4, projectGeneral: 2, projectNoEvaluating: 1, projectNoFailing: 0 },
			{ projectTypeName: '应急处置', projectTypeAST: '72', projectName: '电务设备故障应急处置', projectAST: '一般', projectSum: 6, projectBest: 1, projectGood: 2, projectGeneral: 2, projectNoEvaluating: 1, projectNoFailing: 0 },
			{ projectTypeName: '应急处置', projectTypeAST: '72', projectName: '工务设备故障应急处置', projectAST: '良好', projectSum: 10, projectBest: 4, projectGood: 4, projectGeneral: 2, projectNoEvaluating: 0, projectNoFailing: 0 },
			{ projectTypeName: '理论知识', projectTypeAST: '90', projectName: '理论考核', projectAST: '掌握', projectSum: 18, projectBest: 12, projectGood: 4, projectGeneral: 2, projectNoEvaluating: 0, projectNoFailing: 0 }
		]
	};
}

// 院校 guid -> 模拟数据
function getMockUserDataMap() {
	return {
		'f760369023c3453bb0917c0869260187': mockUserDataA(),
		'86f7b581e9cd4613bc58e76c3cc8cf3d': mockUserDataB(),
		'a4c15b121b2b4e82841a2eea30441c10': mockUserDataB(),
		'71f98248c0f5480cb0a99b0dbc761c31': mockUserDataB()
	};
}
// ==================== 数据墙模拟数据 end ====================

export default {
	data() {
		return {
			// 选择器
			options: [],
			value: '',
			value1: '',
			options1: [],
			dateacti: 0,
			tableData: [
				{
					name: '理论知识',
					evaluation: 90,
					abilitynamee: '理论考核',
					abilitevaluation: 98,
					totole: 1,
					scuuss: 1,
					fine: '',
					sort: '',
					notmaster: '',
					notevaluated: ''
				},
				{
					name: '基本功能',
					evaluation: 85,
					abilitynamee: 'CTC软件基本操作',
					abilitevaluation: 85,
					totole: 46,
					scuuss: 33,
					fine: 4,
					sort: 3,
					notmaster: 3,
					notevaluated: 3
				},
				{
					name: '电务设备故障应急处置',
					evaluation: 32.11,
					abilitynamee: 'CTC软件基本操作',
					abilitevaluation: 85,
					totole: 46,
					scuuss: 33,
					fine: 4,
					sort: 3,
					notmaster: 3,
					notevaluated: 3
				},
				{
					name: '电务设备故障应急处置',
					evaluation: '',
					abilitynamee: 'CTC软件基本操作',
					abilitevaluation: 85,
					totole: 46,
					scuuss: 33,
					fine: 4,
					sort: 3,
					notmaster: 3,
					notevaluated: 3
				}
			],
			traintimer: [],
			trainfllist: [
				{
					value: 40,
					name: '基本技能',
					per: 20
				},
				{
					value: 38,
					name: '理论知识',
					per: 30
				},
				{
					value: 32,
					name: '自然灾害处置应急',
					per: 20
				},
				{
					value: 30,
					name: '公务应急故障处置设置',
					per: 10
				},
				{
					value: 28,
					name: '电务设备故障应急处置',
					per: 20
				}
			],
			scoreschars: [],
			ability: [],
			options4s: {},
			option3s: {},
			option1s: {},
			option2s: {},
			siguids: '',
			usersa: {},
			datenows: 'week',
			Comprehensive: [],
			projectsta: [],
			pageindex: 1,
			traindatastalist: [],
			traindatastaobj: {},
			keyname: [],
			traindatastalista: [],
			allindex: 0,
			isdatastanum: 0,
			projectstabname: [],
			projectstab: [],
			//
			addbiltysboxvontentwidth1: 0,
			addbiltysboxvontentwidth2: 0,
			titletrnodenumswidth: 0,
			projectsumalldom: 0,
			testuids: '',
			tesoptions: [],
			// ===== 模拟数据开关 =====
			siguidnewlogins: '',
			openbtntext: false,
			mockEnable: false,
			siguidMockDataMap: getMockUserDataMap()
		};
	},
	computed: {
		// 当前院校的模拟数据配置
		getCurrentMockData() {
			if (!this.mockEnable) return null;
			return this.siguidMockDataMap[this.siguidnewlogins] || null;
		}
	},
	created() {
		AppOptions.appEmpty = true;
		this.siguids = this.$route.query.siguid;
	},
	// beforeRouteLeave(to, from, next) {
	// 	// AppOptions.appEmpty = false;
	// 	// document.querySelector('body').setAttribute('style', '');
	// 	next();
	// },
	beforeRouteEnter(to, from, next) {
		// 添加背景色 margin:0;padding:0是为了解决vue四周有白边的问题
		document.querySelector('body').setAttribute('style', 'margin:0;padding:0');
		next();
	},
	mounted() {
		// 判断当前院校是否开放「开启 / 关闭」模拟数据开关
		// 优先取地址栏上的院校（跨院校查看时 localStorage 里是登录用户自己的院校）
		this.siguidnewlogins = this.siguids || localStorage.getItem('siguid');
		this.mockEnable = MOCK_SCHOOL_GUIDS.includes(this.siguidnewlogins) || localStorage.getItem('datawallMock') === '1';

		// 获取接口
		this.getclassinfo();

		let myCharts3 = this.$echarts.getInstanceByDom(document.getElementById('censuscharts'));
		if (myCharts3 == null) {
			myCharts3 = this.$echarts.init(document.getElementById('censuscharts'));
		}

		myCharts3.setOption(this.option3s);

		let myCharts2 = this.$echarts.getInstanceByDom(document.getElementById('scores'));
		if (myCharts2 == null) {
			myCharts2 = this.$echarts.init(document.getElementById('scores'));
		}

		let that = this;
		let myCharts1 = this.$echarts.getInstanceByDom(document.getElementById('usermitemchats'));
		if (myCharts1 == null) {
			myCharts1 = this.$echarts.init(document.getElementById('usermitemchats'));
		}

		// myCharts1.setOption(this.option1s)

		let myCharts4 = this.$echarts.getInstanceByDom(document.getElementById('timercensus'));
		if (myCharts4 == null) {
			myCharts4 = this.$echarts.init(document.getElementById('timercensus'));
		}

		window.addEventListener('resize', function() {
			myCharts1.resize();
			myCharts2.resize();
			myCharts3.resize();
			myCharts4.resize();

			let biltysboxvontentwidth1 = document.querySelector('.projecttypename').offsetWidth;
			let biltysboxvontentwidth2 = document.querySelector('.projecttypeast').offsetWidth;
			let titletrnodenumswidth2 = document.querySelector('.titletrnodenums').offsetWidth + 0.33;
			let addbiltysboxvontentwidth2 = document.querySelector('.projectname').offsetWidth + document.querySelector('.projectast').offsetWidth;

			let projectsumall =
				parseInt(document.querySelector('.projectsum').offsetWidth) +
				parseInt(document.querySelector('.projectbest').offsetWidth) +
				parseInt(document.querySelector('.projectgood').offsetWidth) +
				parseInt(document.querySelector('.projectgeneral').offsetWidth) +
				parseInt(document.querySelector('.projectnoevaluating').offsetWidth) +
				parseInt(document.querySelector('.projectnofailing').offsetWidth);

			setTimeout(() => {
				that.addbiltysboxvontentwidth1 = biltysboxvontentwidth1 + biltysboxvontentwidth2;
				that.titletrnodenumswidth = titletrnodenumswidth2 + 1;
				that.addbiltysboxvontentwidth2 = addbiltysboxvontentwidth2;
				that.projectsumalldom = projectsumall + 1;
			}, 200);
		});
	},
	updated() {},
	methods: {
		// 开启 / 关闭 模拟数据
		openbtnshowtext() {
			this.openbtntext = !this.openbtntext;
			const mockData = this.getCurrentMockData;

			if (this.openbtntext) {
				if (!mockData) {
					// 该院校没有配置模拟数据，保持真实接口数据
					this.openbtntext = false;
					return;
				}

				// 学员基本信息
				this.usersa = Object.assign({}, mockData.usersa);

				// 综合实训技能（雷达图）
				this.ability = mockData.ability.slice();
				this.Comprehensive = mockData.comprehensive.map(item => Object.assign({}, item));
				this.$nextTick(() => {
					this.getusercharts();
				});

				// 实训成绩（分）
				this.scoreschars = mockData.scoreschars.map(item => item.slice());
				this.$nextTick(() => {
					this.setscoreschars();
				});

				// 实训时长统计
				this.traintimer = mockData.traintimer.slice();
				this.$nextTick(() => {
					this.settimercensus();
				});

				// 实训项目实训时长统计
				this.projectstabname = mockData.projectstabname.slice();
				this.projectstab = mockData.projectstab.slice();
				this.projectsta = mockData.projectstabname.map((name, index) => ({
					name: name,
					projectName: name,
					timeSQT: mockData.projectstab[index],
					value: mockData.projectstab[index]
				}));
				this.$nextTick(() => {
					this.setcensuschats();
				});

				// 实训数据模型表格
				this.renderTrainDataTable(mockData.tableData.map(item => Object.assign({}, item)));
			} else {
				// 关闭：清空模拟数据，恢复真实接口数据
				this.value1 = '';
				this.testuids = '';
				this.usersa = {};
				this.ability = [];
				this.Comprehensive = [];
				this.scoreschars = [];
				this.traintimer = [];
				this.projectstabname = [];
				this.projectstab = [];
				this.projectsta = [];
				this.traindatastalist = [];
				this.isdatastanum = 0;
				let tableEl = document.querySelector('#tablestow');
				if (tableEl) tableEl.innerHTML = '';

				this.getclassinfo();
			}
		},

		getstelist() {
			GetyyTrainEquipmentList(this.siguids).then(async res => {
				// console.log('设备列表', res.data.data);
				this.tesoptions = res.data.data;
				if (this.tesoptions.length > 0) {
					this.testuids = this.tesoptions[0].sx_te_guid;
					// 请求
					this.$nextTick(() => {
						this.getstudeleng();
						this.getstudentereslist();
						this.getcompersta();
						this.getmyprosta();
						this.getusers();
						this.getusertable();
					});
				}
			});
		},
		showtitle(val, nums) {
			// 显示title
			// options cla_name  ui_realName
			let idnames;
			if (nums == 0) {
				if (this.options.length > 0) {
					if (val) {
						idnames = this.options.filter(ite => ite.cla_guid == val);

						if (idnames.length > 0) {
							return idnames[0].cla_name;
						}
					}
				}
			} else if (nums == 1) {
				if (this.options1.length > 0) {
					if (val) {
						idnames = this.options1.filter(ite => ite.ui_guid == val);

						if (idnames.length > 0) {
							return idnames[0].ui_realName ?? '';
						}
					}
				}
			} else if (nums == 2) {
				if (this.tesoptions.length > 0) {
					if (val) {
						idnames = this.tesoptions.filter(ite => ite.sx_te_guid == val);

						if (idnames.length > 0) {
							return idnames[0].te_deviceName ?? '';
						}
					}
				}
			}
			return '';
		},

		changesprona(i) {
			// console.log(this.traindatastalist[i])
			if (this.traindatastalist[i]) {
				return this.traindatastalist[i].projectTypeName;
			}
		},
		changesprhanhan(i) {
			if (this.traindatastalist[i]) {
				// console.log(this.traindatastalist[i].value.length);
				return this.traindatastalist[i].value.length;
			}
		},
		changesore(date) {
			this.datenows = date;
			this.getstudentereslist();
		},
		changeselect() {
			// console.log(this.value)
			this.options1 = [];
			if (this.value == '') {
				this.value1 = '';
			} else {
				this.getstudents(1);
			}
		},
		selectstelist() {
			// console.log('查询设备名字');
			// 改变设备获取请求
			// 请求
			this.getstudeleng();
			this.getstudentereslist();
			this.getcompersta();
			this.getmyprosta();
			this.getusers();
			this.getusertable();
		},

		selectuser() {
			// console.log("查询学员名字")
			if (this.value1 == '') {
				// this.$message('请选择学员！');
				// this.projectstab = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
				// this.projectstabname = ['ctc软件基本操作', '自然灾害应急处理', '理论考核', '电务设备故障应急处置', '公务设备故障应急处置'];
				//
				this.setcensuschats();
				document.querySelectorAll('.titletrnode').forEach(item => {
					// console.log(item);
					item.parentNode.removeChild(item);
				});
				this.isdatastanum = 0;
				this.scoreschars = [
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					}
				];
				this.setscoreschars();

				this.usersa.timeLength = 0;

				this.usersa.ui_realName = '暂无学生信息';
				this.usersa.ui_joyNumber = '';

				this.ability = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
				this.Comprehensive.forEach(item => {
					item.value = 0;
				});
				this.getusercharts();

				this.traintimer = [0, 0, 0, 0, 0];
				this.settimercensus();

				// console.log(this.options.filter(item=> item.cla_guid==this.value),"获取")
				this.usersa.cla_name = this.options.filter(item => item.cla_guid == this.value)[0].cla_name;

				return;
			}

			this.getusers();
			this.getstudeleng();
			this.getstudentereslist();
			this.getcompersta();
			this.getmyprosta();

			this.getusertable();
		},
		getclassinfo() {
			GetClassInfoList(this.siguids).then(res => {
				// console.log(res,"班级")
				this.options = res.data.data;
				if (this.$route.query.cla_guid == null) {
					this.value = res.data.data[0].cla_guid;
				} else {
					this.value = this.$route.query.cla_guid;
				}

				// this.options.unshift({
				// 	cla_guid: '',
				// 	cla_name: '班级名称'
				// })
				this.getstudents();
			});
		},
		getstudents(num) {
			let students = {
				si_guid: this.siguids,
				cla_guid: this.value
			};
			GetStudentInfoList(students).then(async res => {
				// console.log(res,"学生列表")
				if (res.data.data.length == 0) {
					this.value1 = '';
					this.selectuser();
					return;
				}

				this.options1 = res.data.data;
				if (this.$route.query.ui_guid == null || num == 1) {
					this.value1 = res.data.data[0].ui_guid;
				} else {
					this.value1 = this.$route.query.ui_guid ?? localStorage.getItem('uiguid');
				}

				// console.log('先执行1这里还是');
				document.querySelectorAll('.titletrnode').forEach(item => {
					item.parentNode.removeChild(item);
				});

				await this.getstelist();
			});
		},
		getusers() {
			GetStudentInfo(this.value1).then(res => {
				this.usersa = res.data.data;
			});
		},
		getusertable() {
			let usertable = {
				ui_guid: this.value1,
				pageIndex: this.pageindex,
				sx_te_guid: this.testuids
			};
			// GetMyTrainDataSTA(usertable).then(res => {
			GetMyTrainDataSTANewApi(usertable).then(res => {
				// console.log(res.data.data, '实训数据报表');
				let list = res && res.data && res.data.data ? res.data.data : [];
				this.renderTrainDataTable(list);
			});
		},

		// 渲染「实训数据模型」表格（真实数据 / 模拟数据共用）
		renderTrainDataTable(array) {
			let that = this;
			this.traindatastalist = [];
			this.traindatastalista = [];

			// 清空旧数据
			let tableEl = document.querySelector('#tablestow');
			if (tableEl) {
				tableEl.innerHTML = '';
			}
			document.querySelectorAll('.titletrnode').forEach(item => {
				if (item) {
					item.parentNode.removeChild(item);
				}
			});

			if (!array || array.length == 0) {
				this.isdatastanum = 0;
				return;
			}

			this.isdatastanum = 1;
			let arrayList = array.map((item, index) => Object.assign({}, item, { listnum: index + 1 }));

			let result = [];
			result = arrayList.reduce((acc, current) => {
				let existing = acc.find(item => item.projectTypeName === current.projectTypeName);
				if (existing) {
					existing.value.push(current);
				} else {
					acc.push(Object.assign({}, current, { value: [current] }));
				}
				return acc;
			}, []);

			let str = '';

			if (result.length > 0) {
				result.forEach(item => {
					let tr = '';
					if (item.value.length > 0) {
						let ddd = 1;
						item.value.forEach(item1 => {
							tr +=
								'<tr class="titletrnode" style=border-inline-width:1px;border-color:#fff;border-bottom:1px;border-bottom-style:inherit;><td class="titletdnum titletrnodenums"  style=width:30.5px;text-align:center;border-inline-width:1px;border-color:#fff;>' +
								item1.listnum +
								'</td>';
							if (ddd == 1) {
								tr +=
									'<td class="titletdnum projecttypename" rowspan=' +
									item.value.length +
									' style=width:84px;border-color:#fff;border-inline-width:1px;>' +
									item.projectTypeName +
									'</td>';
								tr +=
									'<td class="titletdnum projecttypeast"  rowspan=' +
									item.value.length +
									' style=width:59px;text-align:center;border-inline-width:1px;border-color:#fff;>' +
									item.projectTypeAST +
									'</td>';
							}
							tr += '<td class="titletdnum projectname" style=border-inline-width:1px;border-color:#fff;width:40px;>' + item1.projectName + '</td>';
							tr +=
								'<td class="titletdnum projectast" style=text-align:center;border-inline-width:1px;border-color:#fff;width:60px;>' +
								item1.projectAST +
								'</td>';
							tr +=
								'<td class="titletdnum projectsum" style=text-align:center;border-inline-width:1px;border-color:#fff;width:40px;>' +
								item1.projectSum +
								'</td>';
							tr +=
								'<td class="titletdnum projectbest" style=text-align:center;border-inline-width:1px;border-color:#fff;width:40px;>' +
								item1.projectBest +
								'</td>';
							tr +=
								'<td class="titletdnum projectgood" style=text-align:center;border-inline-width:1px;border-color:#fff;width:40px;>' +
								item1.projectGood +
								'</td>';
							tr +=
								'<td class="titletdnum projectgeneral" style=text-align:center;border-inline-width:1px;border-color:#fff;width:40px;>' +
								item1.projectGeneral +
								'</td>';
							tr +=
								'<td class="titletdnum projectnoevaluating" style=text-align:center;border-inline-width:1px;border-color:#fff;width:40px;>' +
								item1.projectNoEvaluating +
								'</td>';
							tr +=
								'<td class="titletdnum projectnofailing" style=text-align:center;border-inline-width:1px;border-color:#fff;width:40px;>' +
								item1.projectNoFailing +
								'</td></tr>';
							ddd += 1;
						});
					}
					str += tr;
				});

				this.$nextTick(() => {
					let tablestow = document.querySelector('#tablestow');
					if (!tablestow) return;
					tablestow.insertAdjacentHTML('beforeend', str);
					this.traindatastalist = result;

					document.querySelectorAll('.titletrnode').forEach(item => {
						item.querySelectorAll('.titletdnum').forEach(itm => {
							itm.style.border = '1px solid #fff';
						});
					});

					if (!document.querySelector('.projecttypename')) return;
					let biltysboxvontentwidth1 = document.querySelector('.projecttypename').offsetWidth;
					let biltysboxvontentwidth2 = document.querySelector('.projecttypeast').offsetWidth;
					let titletrnodenumswidth2 = document.querySelector('.titletrnodenums').offsetWidth + 1;
					let addbiltysboxvontentwidth2 = document.querySelector('.projectname').offsetWidth + document.querySelector('.projectast').offsetWidth;

					let projectsumall =
						parseInt(document.querySelector('.projectsum').offsetWidth) +
						parseInt(document.querySelector('.projectbest').offsetWidth) +
						parseInt(document.querySelector('.projectgood').offsetWidth) +
						parseInt(document.querySelector('.projectgeneral').offsetWidth) +
						parseInt(document.querySelector('.projectnoevaluating').offsetWidth) +
						parseInt(document.querySelector('.projectnofailing').offsetWidth);

					setTimeout(() => {
						that.addbiltysboxvontentwidth1 = biltysboxvontentwidth1 + biltysboxvontentwidth2;
						that.titletrnodenumswidth = titletrnodenumswidth2;
						that.addbiltysboxvontentwidth2 = addbiltysboxvontentwidth2;
						that.projectsumalldom = projectsumall + 1;
					}, 200);
				});
			}
		},

		changecurrent(e) {
			// console.log(e)

			this.pageindex = e;
			// console.log('先执行2这里还是');
			this.getusertable();
		},
		// 去重
		unique(arr) {
			const res = new Map();
			return arr.filter(a => !res.has(a.projectName) && res.set(a.projectName, 1));
		},
		callbackgr() {
			this.$router.back();
		},
		getmyprosta() {
			// GetMyProjectSTA(this.value1).then(res => {
			GetMyProjectSTANewApi({
				ui_guid: this.value1,
				sx_te_guid: this.testuids
			}).then(res => {
				// console.log(res.data.data, '实训项目分类统计');
				this.projectsta = res.data.data;

				if (this.projectsta.length > 0) {
					let projectsta = [];
					let projectstabname = [];
					this.projectsta.forEach(item => {
						item.name = item.projectName;
						item.value = item.timeSQT;
						projectsta.push(item.timeSQT);
						projectstabname.push(item.projectName);
					});
					// console.log(this.projectstabname, this.projectstab, '获取list');
					this.projectstabname = projectstabname;
					this.projectstab = projectsta;
					this.$nextTick(() => {
						this.setcensuschats();
					});
				}

				/*
				 else {
				 	this.projectstab = [0, 0, 0, 0, 0];
				 	this.projectstabname = ['ctc软件基本操作', '自然灾害应急处理', '理论考核', '电务设备故障应急处置', '公务设备故障应急处置'];
				 }

				 */
				// console.log(this.projectsta, '实训项目对象');
			});
		},
		getcompersta() {
			// GetMyComprehensiveSTA(this.value1).then(res => {
			GetMyComprehensiveSTAPi({
				ui_guid: this.value1,
				sx_te_guid: this.testuids
			}).then(res => {
				// console.log('能力分析', res.data);

				this.ability = [];
				this.Comprehensive = res.data.data.list;
				if (res.data.data.list.length == 0) {
					this.ability = [];

					this.Comprehensive = [];
				} else {
					res.data.data.list.forEach(item => {
						this.ability.push(item.projecScore);
						item.name = item.projectName;
						item.value = item.projecScore;
					});
					let mathmax = Math.max(...this.ability);
					// let Comprehensive = []
					this.Comprehensive.forEach(item => {
						item.max = mathmax + 10;
						item.text = item.name;
					});
				}
				// console.log(this.Comprehensive,"综合实训技能")
				this.getusercharts();
			});
		},

		getstudeleng() {
			// GetStudentTimeLength(this.value1).then(res => {
			GetStudentTimeLengthApi({
				ui_guid: this.value1,
				sx_te_guid: this.testuids
			}).then(res => {
				// console.log(res.data.data,'获取实训时长统计信息')
				let traintimer = [];
				if (res.data.data.length == 0) {
					traintimer = [0, 0, 0, 0];
				} else {
					res.data.data.forEach(item => {
						traintimer.push(item.count);
					});
				}

				this.traintimer = traintimer;
				this.settimercensus();
			});
		},
		getstudentereslist() {
			let resltdata = {
				ui_guid: this.value1,
				type: this.datenows,
				sx_te_guid: this.testuids
			};
			// console.log("成绩>>>>",this.value1)

			// GetStudentResultsDataList(resltdata).then(res => {
			GetStudentResultsDataListApi(resltdata).then(res => {
				// console.log(res, '成绩');
				let scoreschars = [];
				if (res.data.data.length > 0) {
					this.scoreschars = [];

					res.data.data.forEach(item => {
						let scoresf = [];
						scoresf.push(item.date);
						scoresf.push(item.count);
						scoreschars.push(scoresf);
					});
				}

				this.scoreschars = scoreschars;
				// console.log(scoreschars, '成绩111');
				this.setscoreschars();
			});
		},

		settimercensus() {
			// console.log(this.traintimer)
			let options = {
				title: {
					text: '实训时长统计',
					textStyle: {
						color: '#fff',
						fontSize: 20,
						fontWeight: 400
					},
					top: '0%',
					left: '5%'
				},
				grid: {
					top: '20%',
					left: '2%',
					right: '2%',
					bottom: '0%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
					axisLabel: {
						show: true,
						textStyle: {
							color: '#FADB71'
						}
					}
				},
				yAxis: {
					type: 'value',
					name: '单位: 小时', //  你的单位写在这就可以
					nameTextStyle: {
						//  单位样式
						color: '#FADB71', //  字体颜色
						fontSize: 14 //  字体大小
					},
					axisLabel: {
						show: true,
						textStyle: {
							color: '#FADB71'
						}
					},
					splitLine: {
						//网格线
						lineStyle: {
							type: 'dashed' //设置网格线类型 dotted：虚线 solid:实线
						},
						show: true //隐藏或显示
					}
				},

				series: [
					{
						label: {
							//数值显示
							show: true, //显示柱状图上每一列的数值
							rotate: 60, //让显示的数值进行旋转
							textStyle: {
								fontSize: 14
							},
							position: 'inside', //标签的位置
							color: '#1c0803'
						},
						data: this.traintimer,
						type: 'bar',
						color: '#FADB71',
						emphasis: {
							focus: 'series', // 在高亮图形时，是否淡出其它数据的图形已达到聚焦的效果。默认值'none'不淡出其它图形，series' 聚焦当前高亮的数据所在的系列的所有图形，'self' 只聚焦（不淡出）当前高亮的数据的图形
							label: {
								show: true
							}
						}
					}
				]
			};

			this.options4s = options;

			let myCharts4 = this.$echarts.getInstanceByDom(document.getElementById('timercensus'));
			if (myCharts4 == null) {
				myCharts4 = this.$echarts.init(document.getElementById('timercensus'));
			}
			// console.log("时长", this.options4s)
			myCharts4.setOption(this.options4s);

			/*
			 markPoint: {
			 	data: [
			 		{
			 			type: 'max',
			 			name: '最大值'
			 		},
			 		{
			 			type: 'min',
			 			name: '最小值'
			 		}
			 	],
			 	itemStyle: {
			 		normal: {
			 			label: {
			 				textStyle: {
			 					color: '#1c0803'
			 				}
			 			}
			 		}
			 	}
			 },*/
		},

		setcensuschats() {
			const zoomData = [
				{
					type: 'inside',
					startValue: 0,
					endValue: 5,
					yAxisIndex: [0],
					zoomOnMouseWheel: true, // 关闭滚轮缩放
					moveOnMouseWheel: true, // 开启滚轮平移
					moveOnMouseMove: true // 鼠标移动能触发数据窗口平移
				},
				{
					type: 'slider',
					realtime: true,
					startValue: 0,
					endValue: 5,
					width: '3.5',
					height: '80%',
					yAxisIndex: [0], // 控制y轴滚动
					fillerColor: 'rgba(154, 181, 215, 1)', // 滚动条颜色
					borderColor: 'rgba(17, 100, 210, 0.12)',
					backgroundColor: '#cfcfcf', //两边未选中的滑动条区域的颜色
					handleSize: 0, // 两边手柄尺寸
					showDataShadow: false, //是否显示数据阴影 默认auto
					showDetail: false, // 拖拽时是否展示滚动条两侧的文字
					top: '1%',
					right: '5'
				}
			];

			var option = {
				title: {
					text: '实训项目实训时长统计（小时）',
					textStyle: {
						//文字颜色
						color: '#fff',
						//字体风格,'normal','italic','oblique'
						fontStyle: 'normal',
						//字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
						fontWeight: 'bold',
						//字体系列
						fontFamily: 'sans-serif',
						//字体大小
						fontSize: 18
					}
				},
				dataZoom: zoomData,
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				grid: {
					top: 80,
					bottom: 30,
					left: 10
				},
				xAxis: {
					type: 'value',
					position: 'top',
					splitLine: {
						lineStyle: {
							type: 'dashed',
							color: '#fff'
						}
					},
					nameTextStyle: {
						//  单位样式
						color: '#fff', //  字体颜色
						fontSize: 14 //  字体大小
					},
					axisLabel: {
						color: '#fff'
					},
					axisLine: {
						color: '#fff'
					}
				},
				yAxis: {
					type: 'category',
					axisLine: { show: false },
					axisLabel: { show: false, color: '#fff' },
					axisTick: { show: false },
					splitLine: { show: false },
					nameTextStyle: {
						show: false,
						//  单位样式
						color: '#fff', //  字体颜色
						fontSize: 14, //  字体大小
						left: 100
					},
					nameGap: 100,
					data: this.projectstabname
				},
				series: [
					{
						name: '',
						type: 'bar',
						stack: 'Total',
						label: {
							show: true,
							textStyle: {
								fontSize: 16
							},
							align: 'left',
							offset: [0, 0],
							color: '#fff',
							formatter: value => {
								// console.log(value.name, '名字表示');
								if (!value.name) return '';
								// 10是截取的字符串长度，根据你的情况调整数值
								if (value.name.length > 10) {
									value.name = value.name.slice(0, 10) + '...';
								}
								return value.name;
							}
						},
						itemStyle: {
							color: '#77EADF'
						},
						data: this.projectstab
					}
				]
			};

			// console.log(option);
			// projectstabname
			// projectstab

			this.option3s = option;
			let myCharts3 = this.$echarts.getInstanceByDom(document.getElementById('censuscharts'));
			if (myCharts3 == null) {
				myCharts3 = this.$echarts.init(document.getElementById('censuscharts'));
			}
			myCharts3.clear();
			myCharts3.setOption(this.option3s);
			myCharts3.resize();
		},

		setscoreschars() {
			var option = {
				title: {
					text: '实训成绩（分）',
					textStyle: {
						color: '#fff',
						fontSize: 20,
						fontWeight: 400
					},
					top: '0%',
					left: '5%'
				},
				tooltip: {
					show: true,
					trigger: 'axis',
					confine: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: true,
					axisLabel: {
						color: '#fff'
					}
				},
				yAxis: {
					type: 'value',
					// boundaryGap: [0, '80%'],
					axisLabel: {
						color: '#fff'
					}
				},
				grid: {
					left: '0%',
					right: '2%',
					top: '15%',
					bottom: '3%',
					containLabel: true
				},
				visualMap: {
					type: 'piecewise',
					show: false,
					dimension: 20,
					seriesIndex: 1,
					pieces: [
						{
							gt: 0,
							lt: 7,
							color: 'rgba(0, 0, 180, 0.4)'
						}
					]
				},
				series: [
					{
						type: 'line',
						smooth: 0.4,
						symbolSize: 5,
						lineStyle: {
							color: '#5470C6',
							width: 2
						},
						markLine: {
							symbol: ['circle', 'circle'],
							label: {
								show: false
							},
							data: [
								{
									xAxis: 0
								},
								{
									xAxis: this.scoreschars.length - 1
								}
							]
						},
						areaStyle: {},
						itemStyle: {
							normal: {
								label: {
									show: true, // 在折线拐点上显示数据
									color: '#fff',
									fontSize: 16
								}
							}
						},
						data: this.scoreschars
					}
				]
			};

			this.option2s = option;
			let myCharts2 = this.$echarts.getInstanceByDom(document.getElementById('scores'));
			if (myCharts2 == null) {
				myCharts2 = this.$echarts.init(document.getElementById('scores'));
			}
			// console.log(this.option2s, '获取请求');
			myCharts2.setOption(this.option2s);
		},

		getusercharts() {
			let option = {
				color: ['#FFE434', '#FFE434', '#56A3F1', '#FF917C'],
				title: {
					text: '综合实训技能',
					textStyle: {
						color: '#fff',
						fontSize: 20,
						fontWeight: 400
					},
					top: '0%',
					left: '5%'
				},
				tooltip: {
					show: true,
					confine: true
				},
				legend: {
					show: false
				},
				radar: [
					{
						indicator: this.Comprehensive,
						center: ['56%', '55%'],
						radius: '60%',
						startAngle: 90,
						splitNumber: 4,
						shape: 'circle',
						axisName: {
							formatter: value => {
								let d;
								this.Comprehensive.map(item => {
									if (item.name == value) {
										d = item.value;
									}
								});
								return [`${value}`, `${d}`].join('\n');
							},
							fontSize: 16,
							color: '#fff'
						},

						splitArea: {
							areaStyle: {
								color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4'],
								shadowColor: 'rgba(0, 0, 0, 0.2)',
								shadowBlur: 10
							}
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(211, 253, 250, 0.8)'
							}
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(211, 253, 250, 0.8)'
							}
						}
					}
				],
				series: [
					{
						name: '综合能力评估',
						type: 'radar',
						min: 0,
						emphasis: {
							lineStyle: {
								width: 4
							}
						},
						data: [
							{
								value: this.ability,
								areaStyle: {
									color: 'rgba(255, 228, 52, 0.6)'
								}
							}
						]
					}
				]
			};
			// console.log(this.ability, '综合能力评估', this.Comprehensive);
			this.option1s = option;
			let myCharts1 = this.$echarts.getInstanceByDom(document.getElementById('usermitemchats'));
			if (myCharts1 == null) {
				myCharts1 = this.$echarts.init(document.getElementById('usermitemchats'));
			}
			myCharts1.setOption(this.option1s);
		}
	},
	components: {
		sacleBox
	}
};
</script>

<style>
.theme-teal {
	background-color: #142131 !important;
}
</style>

<style scoped lang="less">
// .titlebox {
// 	width: 100%;
// 	position: relative;
// 	.titletr {
// 		width: 100%;
// 	}
// }
.tablesbox {
	display: flex;
	align-content: center;
	width: 100%;

	.tablesboxtr {
		display: flex;
		flex-direction: column;
		align-items: center;
		.biltysbox {
			color: #fff;
			border: 1px solid #fff;
			background: #04428e;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 16px;
			box-sizing: border-box;
		}
		p {
			font-size: 16px;
			width: 100%;
			height: 100%;
			color: #fff;
			border: 1px solid #fff;
			background: #04428e;
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
		}

		.biltysboxvontent {
			display: flex;
			box-sizing: border-box;
			width: 100%;
		}
	}

	.tablesboxtrend {
		p {
			border-top: none !important;
		}
		p:first-child {
			border-right: none;
		}
		p:first-child {
			border-right: none;
		}
	}
}

.tdprojectname {
	// width: 60px !important;
	// white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.pagination {
	margin: 10px 0 0 1rem;
	color: #fff;
	font-size: 0.8rem;
	display: flex;
	align-items: center;

	.paginationp {
		margin-right: 20%;
		font-weight: 400;
	}

	/deep/ .el-pagination {
		button {
			padding: 0 20px;
			background: rgba(0, 0, 0, 0);
			border: 1px solid #fff;
			color: #fff;
		}

		li {
			background: rgba(0, 0, 0, 0);
			border: 1px solid #fff;
			color: #fff;
		}
	}
}

.taablessc::-webkit-scrollbar {
	display: none;
}

.taablessc::-webkit-scrollbar {
	/*滚动条整体样式*/
	width: 4px;
	/*高宽分别对应横竖滚动条的尺寸*/
	height: 1px;
}

.taablessc::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	border-radius: 10px;
	box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
	background: #78b4b4;
}

.taablessc::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
	border-radius: 10px;
	background: #ededed;
}

.tables {
	width: 100%;
	height: 100%;
	color: #fff;
	font-size: 1rem;
	position: relative;
	// text-align: center;

	.titletr {
		text-align: center;
		td {
			border-bottom: 1px solid #fff;
		}

		th {
			border: 1px solid #fff;
		}
	}

	tr {
		height: 20px;
		// text-align: center;
	}

	tr td:first-child {
		text-align: center;
	}

	th {
		border: 1px solid #fff;
		height: 20px;
		text-align: center;
	}

	td {
		border: 1px solid #fff;
		height: 20px;
		// text-align: center;
		width: 60px;
	}
}

.datechoice {
	display: flex;
	align-items: center;
	position: absolute;
	top: 8%;
	right: 5%;
	color: #fff;
	width: 20%;
	font-size: 1rem;
	justify-content: space-between;
	cursor: pointer;
}

.dateactives {
	color: #84f602;
}

.usermessages {
	padding: 20px;
	width: 100%;
	height: 45%;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	.usermessagelist {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
	}

	.usermitem {
		width: 15%;
		height: 100%;
		// display: flex;
		// flex-direction: column;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;

		.usermitems {
			position: relative;

			.usermitestect {
				height: 64%;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				transform: translate(24px, 18px);

				/deep/ .el-select {
					width: 100%;

					.el-input__inner {
						background-color: rgba(255, 255, 255, 0);
						// border: 3px solid #fff;
						color: #fff !important;
						font-size: 1.2rem;
						padding: 20px;
					}
				}
			}

			.sctends {
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.bordertop {
				width: 175px;
				height: 60px;
				position: absolute;
			}

			.borderbottom {
				width: 60px;
				height: 150px;
				position: absolute;
				bottom: 0;
				right: 0%;
			}
		}

		.usermename {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			width: 65%;
		}

		.usermesbox {
			width: 90%;
			height: 28%;
			margin: 0 auto;
			background-color: #d9523f;
			padding: 0 1rem;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			border-radius: 2px;
			overflow: hidden;

			p {
				color: #fff;
				font-size: 1.2rem;
			}
		}

		.usermesbox:first-child {
			margin-top: 20px;
		}

		.usermesbox:last-child {
			margin-bottom: 20px;
		}

		.bordertop {
			width: 175px;
			height: 60px;
			position: absolute;
		}

		.borderbottom {
			width: 60px;
			height: 170px;
			position: absolute;
			bottom: 0;
			right: 0%;
		}
	}
}

.usertitles {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	height: 10%;
	position: relative;

	.userimg {
		width: 90vw;
		height: 100%;
		height: 10vh;
	}

	.usertiefonts {
		font-size: 3rem;
		position: absolute;
		left: 5.5%;
		top: 10%;
		color: #fff;
	}

	.userback {
		width: 20%;
		height: 100%;
		box-sizing: border-box;
		background-color: #04428e;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		span {
			font-size: 2rem;
			color: #fff;
		}
	}
}

.appconten {
	background: url('../../images/datetolines.png') no-repeat center;
	// background-size: 100% auto;
	width: 100%;
	height: 100%;
	background-size: 100% 100%;
	// height: 1080px;
	box-sizing: border-box;
	overflow: hidden;
}

.paginationno {
	width: 97%;
	margin: 0 auto;
	height: 40%;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 30px;
}

#table .titletrnode {
	border: 1px solid #fff !important;
}

#table .titletdnum {
	border: 1px solid #fff !important;
}

#table tr {
	border: 1px solid #fff !important;
}
#table td {
	border: 1px solid #fff !important;
}

/* 开启 / 关闭 模拟数据按钮 */
.openclosebtn {
	position: fixed;
	top: 14px;
	right: 0;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 20px;
	font-size: 14px;
	color: #fff;
	background-color: #0e94ea;
	cursor: pointer;
	z-index: 9999;
}

.openclosebtn:hover {
	color: #ed405d;
}
</style>
